if (!customElements.get('sa-why-see-action-carousel')) {

  class SaWhySeeActionCarousel extends HTMLElement {
    constructor() {
      super();
      this.handlePrev = this.handlePrev.bind(this);
      this.handleNext = this.handleNext.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.sa-why-see-action__track');
      this.prevBtn = this.querySelector('.sa-why-see-action__btn--prev');
      this.nextBtn = this.querySelector('.sa-why-see-action__btn--next');
      this.progressBar = this.querySelector('.sa-why-see-action__progress-bar');

      if (!this.track) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.handlePrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });

      this.updateProgress();
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);
      if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
    }

    getCardWidth() {
      const card = this.track.querySelector('.sa-why-see-action__card');
      if (!card) return 362;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 16;
      return card.offsetWidth + gap;
    }

    handlePrev() {
      if (!this.track) return;
      this.track.scrollBy({ left: -this.getCardWidth(), behavior: 'smooth' });
    }

    handleNext() {
      if (!this.track) return;
      this.track.scrollBy({ left: this.getCardWidth(), behavior: 'smooth' });
    }

    handleScroll() {
      this.updateProgress();
    }

    updateProgress() {
      if (!this.track || !this.progressBar) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0) {
        this.setAttribute('data-has-overflow', 'false');
        this.progressBar.style.width = '100%';
        if (this.prevBtn) this.prevBtn.disabled = true;
        if (this.nextBtn) this.nextBtn.disabled = true;
        return;
      }
      this.setAttribute('data-has-overflow', 'true');
      const pct = (scrollLeft / maxScroll) * 100;
      this.progressBar.style.width = Math.min(100, Math.max(0, pct)) + '%';
      if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
      if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }
  }

  customElements.define('sa-why-see-action-carousel', SaWhySeeActionCarousel);
}
